"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        display: 'block',
        width: '100%',
        height: '100%',
        fill: 'currentColor',
        '& *': {
            transformOrigin: `50%`,
            transitionTimingFunction: 'ease-in-out',
            transitionDuration: '250ms',
            strokeLinejoin: 'round'
        },
        '& [data-name="bg"]': {
            fill: theme.indigoPastel2,
            opacity: 0,
            transitionProperty: 'opacity'
        },
        '& [data-name="eye"]': {
            strokeWidth: 4,
            fill: 'transparent',
            stroke: 'currentColor'
        },
        '& [data-name="retina"]': {
            strokeWidth: 4,
            fill: 'transparent',
            stroke: 'currentColor',
            transitionProperty: 'stroke-width, fill'
        },
        '& [data-name="slash"]': {
            opacity: 1,
            transform: `scaleY(1) rotate(30deg)`,
            transitionProperty: `opacity, transform`
        },
        '& [data-name="mask-left"]': {
            transform: `rotate(30deg) translateX(0)`,
            transitionProperty: `transform`
        },
        '& [data-name="mask-right"]': {
            transform: `rotate(30deg) translateX(0)`,
            transitionProperty: `transform`
        },
        // FOCUSED
        ':focus:not(:active) > &': {
            '& [data-name="bg"]': {
                opacity: 1
            }
        },
        // CHECKED
        '[aria-checked="false"]:hover > &, [aria-checked="true"]:not(:hover) > &': {
            '& [data-name="retina"]': {
                strokeWidth: 0,
                fill: 'currentColor'
            },
            '& [data-name="slash"]': {
                opacity: 0,
                transform: `scaleY(0) rotate(0deg)`
            },
            '& [data-name="mask-left"]': {
                transform: `rotate(30deg) translateX(6px)`
            },
            '& [data-name="mask-right"]': {
                transform: `rotate(30deg) translateX(-6px)`
            }
        }
    }
});
//# sourceMappingURL=visibility.icon.style.js.map